import { parseNumber } from '../../utils/number.utils';
import { isArray } from 'util';
import { Adapter } from '../adapter';

export class AdapterBuilder {
  static fromJson(json) {
    return (json)
      ? new Adapter(
        json.hash,
        json.name,
        parseNumber(json.type)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(AdapterBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/adapter.builder.ts